// frontend/src/components/matching/MatchedFieldsBadges.jsx
import "./Matching.css";

export default function MatchedFieldsBadges({ matchedFields }) {
  if (!matchedFields) return null;
  return (
    <div className="mt-field-badges">
      {Object.entries(matchedFields).map(([key, info]) => (
        <span
          key={key}
          className={info.matched ? "ds-badge ds-badge--success" : "ds-badge"}
          title={`LV: ${info.lv_value} | Catalog: ${info.catalog_value || "—"}`}
        >
          {key.split("→")[0]}
        </span>
      ))}
    </div>
  );
}
